<template>
  <span>
    <b-badge
      v-if="page.is_draft && !skip.includes('draft')"
      class="mr-1"
      :to="{ name: 'pages', query: { type: 'drafts' } }"
      >Draft</b-badge
    >
    <b-badge
      v-if="page.approved_at && !skip.includes('optimized')"
      class="mr-1"
      :to="{ name: 'pages', query: { type: 'optimized' } }"
      >Optimized</b-badge
    >
    <b-badge
      v-if="isPdf && !skip.includes('pdf')"
      class="mr-1"
      variant="light"
      :to="{ name: 'pages', query: { q: 'pdf' } }"
      >PDF</b-badge
    >
    <b-badge
      v-else-if="page.status_code != 200 && !skip.includes('error')"
      class="mr-1"
      :variant="isRedirect ? 'warning' : 'danger'"
      :title="`The page responded with a ${page.status_code} status code`"
      :to="{ name: 'pages', query: { type: 'errors' } }"
      >{{ page.status_code }}</b-badge
    >
    <!-- <b-badge
      v-if="isReverted && !skip.includes('reverted')"
      class="mr-1"
      variant="danger"
      v-b-tooltip.hover
      :title="
        `This optimization was reverted because it reduced clicks by ${page.gain *
          100}%`
      "
      >Reverted</b-badge
    >
    <span
      v-else-if="isLowGain && !skip.includes('loser')"
      class="mr-1"
      v-b-tooltip.hover
      :title="
        `This optimization looks to have reduced clicks by ${page.gain *
          100}%`
      "
    >
      <b-icon-exclamation-triangle-fill variant="danger" />
    </span> -->
    <b-badge v-for="page_tag in page.page_tags" :key="page_tag.tag.id" class="mr-1" :to="!editable ? {name:'pages', query:{...$route.query,q:page_tag.tag.name}} : false">
      {{ page_tag.tag.name }}
      <b-link class="hover-menu text-decoration-none text-white" @click="removeTag(page_tag.tag.id)" v-if="editable">×</b-link>
    </b-badge>
  </span>
</template>
<script>
import {get} from 'lodash'
import PAGE_QUERY from '@/graphql/PageQuery.gql'
import PAGE_TAG_DELETE from '@/graphql/PageTagDelete.gql'
export default {
  name: 'PageTags',
  components: { },
  props: {
    page: Object,
    editable: Boolean,
    skip: {
      type: Array,
      default: () => []
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagName: null,
      tags: [],
    }
  },

  computed: {
    isRedirect() {
      return [301,302].includes(this.page.status_code)
    },
    isPdf() {
      return get(this, 'page.url', '').endsWith('.pdf')
    },
    isLowGain() {
      return this.page.gain <= -0.05
    },
    isReverted() {
      return this.isLowGain && !this.page.approved_at
    },
  },
  methods: {
    async removeTag(page_tag_id) {
      await this.$apollo.mutate({
        mutation: PAGE_TAG_DELETE,
        variables: {
          page_id: this.page.id,
          tag_id: page_tag_id
        }
      })
      await this.$apollo.query({
        query: PAGE_QUERY,
        variables: {
          id: this.page.id
        }
      })
    }
  }
}
</script>
